import { render, staticRenderFns } from "./Confirmation_User.vue?vue&type=template&id=81b0f7b6&scoped=true&"
import script from "./Confirmation_User.vue?vue&type=script&lang=js&"
export * from "./Confirmation_User.vue?vue&type=script&lang=js&"
import style0 from "./Confirmation_User.vue?vue&type=style&index=0&id=81b0f7b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b0f7b6",
  null
  
)

export default component.exports